import { Tooltip, Typography } from 'antd'

const TableIdCopy = ({ id }: { id: string }) => {
  const LENGTH = 8
  const truncate = id.length > LENGTH
  const truncatedID = truncate
    ? `…${id.slice(id.length - LENGTH, id.length)}`
    : id.padStart(LENGTH, ' ')

  const copy = (
    <Typography.Text
      style={{ width: 110, display: 'flex' }}
      copyable={{ text: id }}
      onCopy={evt => {
        // If this is in a link, don't follow it if copy icon is clicked
        evt.stopPropagation()
      }}
    >
      <Typography.Text code>{truncatedID}</Typography.Text>
    </Typography.Text>
  )

  if (!truncate) {
    return copy
  }

  return (
    <Tooltip
      placement="bottomRight"
      mouseEnterDelay={0.5}
      title={
        <code
          style={{
            // Just about enough for monospaced uuid to fill the
            // fixed tooltip width
            fontSize: 10.8,
            whiteSpace: 'nowrap',
            background: 'transparent',
          }}
        >
          {id}
        </code>
      }
    >
      {copy}
    </Tooltip>
  )
}

export default TableIdCopy
